import React from 'react';
import dayjs from 'dayjs';
import { Card } from 'antd';

interface TimelineTabProps {
  changeRequests: any[];
}

export const BusinessTimelineTab: React.FC<TimelineTabProps> = ({
  changeRequests,
}) => {
  if (changeRequests.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
        No change requests found
      </div>
    );
  }

  const getFieldLabel = (fieldName: string): string => {
    const fieldLabels: Record<string, string> = {
      name: 'Business Name',
      registration_no: 'Registration No.',
      sst_no: 'SST No.',
      tin_no: 'TIN No.',
      bank: 'Bank',
      main_address: 'Main Address',
      trademark_logo: 'Trademark Logo',
      industry_specific_license: 'Industry Specific License',
      company_chop: 'Company Chop',
    };
    return fieldLabels[fieldName] || fieldName;
  };

  const formatDate = (dateString?: string): string => {
    if (!dateString) return '';
    return dayjs(dateString).format('DD/MM/YYYY HH:mm');
  };

  const getActionText = (request: any): string => {
    if (request.status === 'approved') {
      const reviewerName = request.reviewer?.name || 'Admin';
      return `${reviewerName} update the ${getFieldLabel(request.field_name).toLowerCase()}`;
    } else if (request.status === 'rejected') {
      const reviewerName = request.reviewer?.name || 'Admin';
      return `${reviewerName} reject change in ${getFieldLabel(request.field_name).toLowerCase()}`;
    } else {
      const requesterName = request.requester?.name || 'User';
      return `${requesterName} request change in ${getFieldLabel(request.field_name).toLowerCase()}`;
    }
  };

  const getTimestamp = (request: any): string => {
    if (request.status === 'approved' && request.reviewed_at) {
      return formatDate(request.reviewed_at);
    } else if (request.status === 'rejected' && request.reviewed_at) {
      return formatDate(request.reviewed_at);
    } else {
      return formatDate(request.requested_at || request.created_at);
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px', position: 'relative' }}>
      {/* Timeline line */}
      <div style={{
        position: 'absolute',
        left: '50%',
        top: 0,
        bottom: 0,
        width: '2px',
        backgroundColor: '#d9d9d9',
        transform: 'translateX(-50%)',
      }} />
      
      <div style={{ position: 'relative' }}>
        {changeRequests.map((request, index) => {
          const hasRequestedAt = request.requested_at !== null && request.requested_at !== undefined;
          const hasReviewedAt = request.reviewed_at !== null && request.reviewed_at !== undefined;
          const displayLeft = hasRequestedAt && !hasReviewedAt;
          
          const cardColor = displayLeft ? '#f6ffed' : '#e6f7ff';
          const nodeColor = displayLeft ? 'green' : 'blue';

          return (
            <div
              key={request.id}
              style={{
                position: 'relative',
                marginBottom: 24,
                minHeight: 60,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* Timeline node */}
              <div style={{
                position: 'absolute',
                left: '50%',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: nodeColor,
                border: '2px solid white',
                transform: 'translateX(-50%)',
                zIndex: 1,
              }} />
              
              {/* Card */}
              <Card
                style={{
                  width: 300,
                  backgroundColor: cardColor,
                  marginLeft: displayLeft ? 'calc(50% - 320px)' : 'calc(50% + 20px)',
                  marginRight: 0,
                  textAlign: 'left',
                }}
              >
                <div style={{ fontWeight: 500, marginBottom: 8, textAlign: 'left' }}>
                  {getActionText(request)}
                </div>
                <div style={{ color: '#999', fontSize: '12px', textAlign: 'left' }}>
                  Last update: {getTimestamp(request)}
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};
